import React from "react";

export default function Ads() {
    return (
        <div className="widget">
            <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5162740208916448" crossorigin="anonymous"></script>
        </div>
    );
}